import { Box, Button } from "@outschool/backpack";
import { Trans, useLocale, useTranslation } from "@outschool/localization";
import { ExternalLink } from "@outschool/ui-components-shared";
import { ModalActionButtons } from "@outschool/ui-legacy-component-library";
import React, { useState } from "react";

import PageModal from "./PageModal";
import WistiaVideo from "./WistiaVideo";

const FirstTimeLearnersVideoModal = ({
  isLive = true
}: {
  isLive?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const locale = useLocale();
  const { t } = useTranslation(
    "client\\components\\FirstTimeLearnersVideoModal"
  );

  return (
    <>
      <Box
        sx={{
          textAlign: "center",
          padding: "1em"
        }}
      >
        {isLive && (
          <>
            <Button variant="link" onClick={() => setIsOpen(true)}>
              {t("Tips for live online classes")}
            </Button>
            <span>{" | "}</span>
          </>
        )}
        <ExternalLink
          url={"https://support.outschool.com/" + locale + "/articles/802757"}
        >
          {t("Help & troubleshooting")}
        </ExternalLink>
      </Box>
      <PageModal open={isOpen} onClose={() => setIsOpen(false)}>
        <Box
          sx={{
            padding: "1em"
          }}
        >
          <WistiaVideo
            src="https://fast.wistia.com/embed/medias/dbeda8ce9m.jsonp"
            asyncClass="wistia_async_dbeda8ce9m"
          />
        </Box>
        <Box
          sx={{
            paddingX: "1em"
          }}
        >
          <Trans t={t}>
            See more{" "}
            <ExternalLink
              url={
                "https://support.outschool.com/" + locale + "/articles/802757"
              }
            >
              tips for live online classes{" "}
            </ExternalLink>
            in the help center.
          </Trans>
        </Box>
        <ModalActionButtons
          primaryLabel={t("Close")}
          hideCancelButton={true}
          onPrimary={() => setIsOpen(false)}
        />
      </PageModal>
    </>
  );
};

export default FirstTimeLearnersVideoModal;
